var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',[(_vm.ready)?_c('employee',{attrs:{"body":_vm.info.body,"invite-url":_vm.inviteUrl}}):_c('base-loader',{attrs:{"type":"image"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }